//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/**
 * The type of navigation action to perform on the mobile shell.
 * This is copied to Rock.Enums.Controls.MobileNavigationActionType.
 * Any changes there or here should be mirrored.
 */
export const MobileNavigationActionType = {
    /** No navigation action should be performed. */
    None: 0,

    /** The current page should be popped off the navigation stack. */
    PopPage: 1,

    /** The navigation stack should be cleared and replaced with a new page. */
    ResetToPage: 2,

    /** The current page should be replaced with a new page. */
    ReplacePage: 3,

    /** A new page should be pushed onto the navigation stack. */
    PushPage: 4,

    /** Dismiss the cover sheet if the current page is currently in one. */
    DismissCoverSheet: 5
} as const;

/**
 * The type of navigation action to perform on the mobile shell.
 * This is copied to Rock.Enums.Controls.MobileNavigationActionType.
 * Any changes there or here should be mirrored.
 */
export const MobileNavigationActionTypeDescription: Record<number, string> = {
    0: "None",

    1: "Pop Page",

    2: "Reset To Page",

    3: "Replace Page",

    4: "Push Page",

    5: "Dismiss Cover Sheet"
};

/**
 * The type of navigation action to perform on the mobile shell.
 * This is copied to Rock.Enums.Controls.MobileNavigationActionType.
 * Any changes there or here should be mirrored.
 */
export type MobileNavigationActionType = typeof MobileNavigationActionType[keyof typeof MobileNavigationActionType];
